import axiosBase from "../../utils/axios/axios";
import axiosBaseSurvey from "../../utils/axios/axiosSurvey";

export const getConsultPeople = async (number, fecha) => {
    try {
        const response = await axiosBase.get(
            `/personas/consulta-datos/buscar_por_documento/?numero_documento=${number}&fecha_expedicion=${fecha}`
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const getSurveyVerificationPeople = async (uuid) => {
    try {
        const response = await axiosBaseSurvey.get(`/${uuid}`);

        return response.data;
    } catch (error) {
        throw error;
    }
};
